import { AppVersion } from './app-version';
import version from './.workspace-version.json';

export const constants = {
	appVersion: new AppVersion(version.release, version.shortSHA),
};
